import { MDBCol, MDBContainer, MDBIcon, MDBRow } from "mdbreact";
import { useEffect, useRef, useState } from "react";
import ReactPaginate from "react-paginate";
import DataTable from "../../../components/DataTable/DataTable";
import PendingForm from "../../../components/Forms/PendingForm";
import Loading from "../../../components/Loading";
import axiosGet from "../../../helpers/axiosGet";
import InvoiceListModal from "./InvoiceListModal";

const createPendingUrl = (page, values) => {
  const params = new URLSearchParams({
    orderId: values?.orderId || "",
    invoiceNo: values?.invoiceNo || "",
    statusCode: values?.statusCode || "",
    minAmount: values?.minAmount || "",
    maxAmount: values?.maxAmount || "",
    startDate: values?.startDate || "",
    endDate: values?.endDate || "",
    maxCount: "",
  });
  return `/invoice/pending-payment/page/${page}?${params.toString()}`;
};

const headers = [
  "Order Number",
  "Invoice Number",
  "Amount",
  "Expired",
  "Status",
  "Link",
];

export default function PendingInvoice({ navigation }) {
  const scroll = useRef(null);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [invoices, setInvoices] = useState([]);
  const [values, setValues] = useState(null);
  const [page, setPage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [bundleInvoices, setBundleInvoices] = useState(null);

  const fetchInvoices = (nextPage = 1, nextValues = values) => {
    setLoading(true);
    axiosGet({
      url: createPendingUrl(nextPage, nextValues),
      callback: (res) => {
        setInvoices(res.data.data);
        setPage(res.data.page - 1);
        setTotalPage(res.data.totalPage);
        setLoading(false);
      },
      errorCallback: (err) => {
        console.log(err);
        setLoading(false);
      },
    });
  };

  useEffect(() => {
    fetchInvoices();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSearch = (searchValues) => {
    setValues(searchValues);
    fetchInvoices(1, searchValues);
  };
  const handleReset = () => {
    setValues(null);
    fetchInvoices(1, null);
  };

  const handlePageChange = ({ selected }) => {
    fetchInvoices(selected + 1);
    scroll.current?.scrollIntoView();
  };

  return (
    <>
      <div className="border rounded mt-5">
        <MDBContainer
          className="px-4 py-2"
          onClick={() => setOpen(!open)}
          style={{ cursor: "pointer" }}
        >
          <MDBRow>
            <MDBCol size="6" middle>
              <p className="mb-0">Search</p>
            </MDBCol>
            <MDBCol size="6" className="text-right">
              <MDBIcon icon={open ? "angle-up" : "angle-down"} size="lg" />
            </MDBCol>
          </MDBRow>
        </MDBContainer>
        {open && <PendingForm onSearch={handleSearch} onReset={handleReset} />}
      </div>

      {navigation}

      <div className="mt-5" ref={scroll}>
        {loading ? (
          <Loading />
        ) : (
          <>
            <div className="p-4 border rounded text-grey">
              <DataTable
                invoices={invoices}
                active="pending"
                headers={headers}
                onBundleClick={setBundleInvoices}
              />
              {!invoices.length && (
                <div className="font-weight-bold text-center mt-3">NO DATA</div>
              )}
            </div>
            {invoices.length > 0 && (
              <div className="mt-5 d-flex justify-content-end">
                {totalPage > 1 && (
                  <ReactPaginate
                    previousLabel={<MDBIcon icon="chevron-left" />}
                    nextLabel={<MDBIcon icon="chevron-right" />}
                    breakLabel="..."
                    pageCount={totalPage}
                    pageRangeDisplayed={2}
                    marginPagesDisplayed={1}
                    forcePage={page}
                    onPageChange={handlePageChange}
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    activeClassName="active"
                  />
                )}
              </div>
            )}
          </>
        )}
      </div>

      <InvoiceListModal
        invoices={bundleInvoices}
        onClose={() => setBundleInvoices(null)}
      />
    </>
  );
}
